import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PledgeDetailComponent } from '../pledge-detail/pledge-detail.component';
import { DevExtremeModule, DxDataGridComponent } from 'devextreme-angular';
import { ArkUnitOfWork, BreezeDxStoreService, AppInformationService, AuthService, UtilityService } from 'app/core/core.module';
import { BsModalService } from 'ngx-bootstrap/modal';
import _ from 'lodash';
import moment from 'moment';
import { alert, confirm } from 'devextreme/ui/dialog';
import { InputDialogComponent } from 'app/shared/input-dialog/input-dialog.component';

@Component({
    selector: 'app-pledge-list',
    templateUrl: './pledge-list.component.html',
    styleUrls: ['./pledge-list.component.scss'],
    imports: [CommonModule, DevExtremeModule],
    standalone: true,
})
export class PledgeListComponent implements OnInit {
    pledges: any[];
    lines: any[];
    noAssociatedPledgeGivings: any;
    noAssociatedPledgeGivingTotal = 0;

    @ViewChild('pledgesGrid') pledgesGrid: DxDataGridComponent;
    @ViewChild('linesGrid') linesGrid: DxDataGridComponent;
    @ViewChild('columns') columns: any[];

    constructor(private uow: ArkUnitOfWork, private modalService: BsModalService, public appInfo: AppInformationService, private auth: AuthService, private utility: UtilityService) {}

    async ngOnInit() {
        await this.getData();
    }

    async getData() {
        this.appInfo.pleaseWaitShow();
        // const pledges = await this.uow.pledges.all('person.lastName', 'person,lines');
        const pledges = await this.uow.getPledges({ orderBy: 'person.lastName', expand: 'person,lines' });
        // this.lines = await this.uow.pledgeLines.all();
        this.lines = await this.uow.getPledgeLines();
        const givings = (await this.uow.getPledgeGiving()) as any;
        this.noAssociatedPledgeGivings = (await this.uow.getNoAssociatedPledgeGiving()) as any;
        this.noAssociatedPledgeGivingTotal = 0;
        let i = 0;
        this.noAssociatedPledgeGivings.forEach((x) => {
            x.id = i++;
            this.noAssociatedPledgeGivingTotal += x.amount;
        });

        pledges.forEach((pledge: any) => {
            const giving = _.find(givings, { familyId: pledge.person.familyId }) as any;
            pledge.givenAmount = giving ? giving.amount : 0;
        });

        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0,
            // These options are needed to round to whole numbers if that's what you want.
            //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
            //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
        });

        pledges.forEach((pledge: any) => {
            let rowNote = '';
            if (!!pledge.lines && pledge.lines.length > 0) {
                _.sortBy(pledge.lines, 'expectedDate').forEach((line) => {
                    rowNote += `${moment(line.expectedDate).format('MM/DD/YY')}--${formatter.format(line.amount)}<br>`;
                });
            }
            pledge.rowNote = rowNote;
        });

        this.pledges = pledges;
        this.appInfo.pleaseWaitHide();
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'before',
            }
        );
    }

    rowDoubleClick(e) {
        if (!e.data || !e.data.id) return;
        this.open(e.data.id);
    }

    open(pledgeId?: number) {
        const modalRef = this.modalService.show(PledgeDetailComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: { pledgeId },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.result) {
                this.getData();
            }
        });
    }

    async delete() {
        const selectedRows = this.pledgesGrid.instance.getSelectedRowsData();
        if (!selectedRows) return;
        console.log(selectedRows);

        const result = await confirm(`Are you sure you want to delete the selected pledges and lines?`, `GRRAFSCHAP`);
        if (!result) return;

        this.appInfo.pleaseWaitShow();
        const today = new Date();
        selectedRows.forEach((row) => {
            row.lines.forEach((line) => {
                line.deleted = today;
                line.deletedBy = this.auth.currentUser.userName;
            });
            row.deleted = today;
            row.deletedBy = this.auth.currentUser.userName;
        });
        await this.uow.commit();
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }

    async openUnAssociatedPledges() {
        const dataSource = this.noAssociatedPledgeGivings.map(x => {return {Id: x.id, Name: x.name, Amount: x.amount }})
        const modalRef = this.modalService.show(InputDialogComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                dialogHeader: 'UnAssociated Givings',
                mode: 'dataGrid',
                dataSource: dataSource,
                storageKey: 'pledge-unAssociated',
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success && result.value) {
            }
            modalRef.hide();
        });
    }

    async printStatements(allInfo?: boolean) {
        // const result = await confirm(
        //     `Are you sure you want to create the yearly statements for all families for ${this.filter.givingYear ? this.filter.givingYear : new Date().getFullYear()}?`,
        //     'Create All Statements?'
        // );
        // if (!result) return;

        this.appInfo.pleaseWaitShow();
        const year = new Date().getFullYear();

        await this.utility.printPledgeStatements(allInfo ? null : year, false);
        this.appInfo.pleaseWaitHide();
    }
}
